(function () {
  if (window.__pkBuyAgainOrderAtcBound) return;
  window.__pkBuyAgainOrderAtcBound = true;

  var HEAD_COLS = [
    ['product', 'column_product'],
    ['price', 'column_price'],
    ['qty', 'column_quantity'],
    ['action', 'column_add'],
  ];

  var SPINNER_SVG =
    '<svg xmlns="http://www.w3.org/2000/svg" class="spinner" viewBox="0 0 66 66"><circle stroke-width="6" cx="33" cy="33" r="30" fill="none" class="path"></circle></svg>';

  function str(x) {
    return x != null ? String(x) : '';
  }

  function dispatchBuyAgain(name, detail) {
    try {
      window.dispatchEvent(new CustomEvent(name, { bubbles: true, cancelable: false, detail: detail || {} }));
    } catch (e) {}
  }

  function publishReorderClick(order) {
    if (!order) return;
    var lines = order.display_lines;
    var n = 0;
    if (Array.isArray(lines)) {
      n = lines.length;
    } else if (Array.isArray(order.cart_lines)) {
      n = order.cart_lines.length;
    }
    const orderId = str(order.name).trim() || str(order.id);
    const orderDate = str(order.created_at_label).trim();
    const data = {
      order_id: orderId,
      item_count: n,
      order_date: orderDate,
    };
    if (window.alteregoAnalytics && typeof window.alteregoAnalytics.trackReorderClick === 'function') {
      window.alteregoAnalytics.trackReorderClick(data);
    }
  }

  var liveRegionTimer;
  function flashLiveRegion(sectionEl, message, clearMs) {
    var live = sectionEl && sectionEl.querySelector('[data-buy-again-live-region]');
    if (!live || !message) return;
    live.textContent = '';
    live.textContent = message;
    window.clearTimeout(liveRegionTimer);
    liveRegionTimer = window.setTimeout(function () {
      live.textContent = '';
    }, clearMs || 7000);
  }

  function getCartUi() {
    return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }

  function appendLabelAndSpinner(btn, label) {
    var span = document.createElement('span');
    span.textContent = str(label);
    btn.appendChild(span);
    var wrap = document.createElement('div');
    wrap.className = 'loading__spinner hidden';
    wrap.innerHTML = SPINNER_SVG;
    btn.appendChild(wrap);
  }

  function setSpinnerVisible(btn, visible) {
    var spin = btn && btn.querySelector('.loading__spinner');
    if (spin) spin.classList.toggle('hidden', !visible);
  }

  function buildFormData(lines) {
    var fd = new FormData();
    var idx = 0;
    var li;
    var line;
    var taxes;
    var ti;
    var t;
    var parentVariantId;
    var qty;
    for (li = 0; li < lines.length; li++) {
      line = lines[li];
      parentVariantId = str(line.id);
      qty = str(line.quantity);
      fd.append('items[' + idx + '][id]', parentVariantId);
      fd.append('items[' + idx + '][quantity]', qty);
      if (line.selling_plan) {
        fd.append('items[' + idx + '][selling_plan]', str(line.selling_plan));
      }
      taxes = Array.isArray(line.tax) ? line.tax : [];
      if (taxes.length > 0) {
        fd.append(
          'items[' + idx + '][properties][_pk_tax_items]',
          JSON.stringify(
            taxes.map(function (x) {
              return {
                id: str(x.id),
                cost: x.cost != null && x.cost !== '' ? str(x.cost) : '',
              };
            })
          )
        );
        for (ti = 0; ti < taxes.length; ti++) {
          t = taxes[ti];
          idx++;
          fd.append('items[' + idx + '][id]', str(t.id));
          fd.append('items[' + idx + '][quantity]', qty);
          fd.append('items[' + idx + '][parent_id]', parentVariantId);
          if (t.cost != null && t.cost !== '') {
            fd.append('items[' + idx + '][properties][_cost]', str(t.cost));
          }
        }
      }
      idx++;
    }
    return fd;
  }

  function labeledCol(i18n, suffix, key, text) {
    var div = document.createElement('div');
    div.className = 'buy-again-order-items__grid-col buy-again-order-items__grid-col--' + suffix;
    div.setAttribute('data-label', str(i18n[key]));
    div.textContent = str(text);
    return div;
  }

  function replaceNamePlaceholder(template, name) {
    return str(template).split('__NAME__').join(str(name));
  }

  function displayLineCartIndex(dl) {
    if (!dl) return -1;
    var v = dl.cart_line_index;
    if (typeof v === 'number' && !isNaN(v)) return v;
    var n = parseInt(v == null ? '-1' : str(v), 10);
    return isNaN(n) ? -1 : n;
  }

  function parseCartLinesFromRoot(root) {
    var payloadEl = root.querySelector('script[type="application/json"][data-buy-again-lines]');
    if (!payloadEl) return { lines: [], parseError: false, parseErrorMessage: '' };
    try {
      var lines = JSON.parse(payloadEl.textContent.trim());
      return { lines: Array.isArray(lines) ? lines : [], parseError: false, parseErrorMessage: '' };
    } catch (err) {
      return {
        lines: [],
        parseError: true,
        parseErrorMessage: err && err.message ? str(err.message) : 'invalid payload',
      };
    }
  }

  function parseJsonEl(el, fallback) {
    if (!el) return fallback;
    try {
      return JSON.parse(el.textContent.trim());
    } catch (e) {
      return fallback;
    }
  }

  function cloneLineWithQuantity(line, qty, cartLineIndex) {
    var out;
    if (typeof structuredClone === 'function') {
      try {
        out = structuredClone(line);
      } catch (e) {
        out = JSON.parse(JSON.stringify(line));
      }
    } else {
      out = JSON.parse(JSON.stringify(line));
    }
    out.quantity = qty;
    if (typeof cartLineIndex === 'number' && !isNaN(cartLineIndex)) {
      out._cart_line_index = cartLineIndex;
    }
    return out;
  }

  function readQtyForCartLine(root, cartLineIndex) {
    var inp = root.querySelector(
      'input.quantity__input[data-buy-again-line-qty][data-cart-line-index="' + cartLineIndex + '"]'
    );
    if (!inp) return 1;
    var min = parseInt(inp.getAttribute('min'), 10);
    if (isNaN(min) || min < 1) min = 1;
    var maxAttr = inp.getAttribute('max');
    var maxN = maxAttr != null && maxAttr !== '' ? parseInt(maxAttr, 10) : null;
    if (maxN != null && isNaN(maxN)) maxN = null;
    var step = parseInt(inp.getAttribute('step') || '1', 10) || 1;
    var n = parseInt(inp.value, 10);
    if (isNaN(n)) n = min;
    if (n < min) n = min;
    if (maxN != null && n > maxN) n = maxN;
    if (step > 1) {
      var rem = (n - min) % step;
      if (rem !== 0) n -= rem;
      if (n < min) n = min;
    }
    inp.value = str(n);
    return n;
  }

  function linesWithQuantitiesForFullOrder(root, allLines) {
    var out = [];
    var i;
    var len = allLines.length;
    for (i = 0; i < len; i++) {
      out.push(cloneLineWithQuantity(allLines[i], readQtyForCartLine(root, i), i));
    }
    return out;
  }

  function updateSelectedAtcState(root) {
    var btn = root.querySelector('[data-buy-again-selected-atc]');
    if (!btn) return;
    btn.disabled = !root.querySelector('input[type="checkbox"][data-buy-again-line-check]:checked');
  }

  function linesFromCheckedSelection(root, allLines) {
    var checked = root.querySelectorAll('input[type="checkbox"][data-buy-again-line-check]:checked');
    var seen = Object.create(null);
    var idxs = [];
    var ci;
    var ch;
    var ix;
    var len = allLines.length;
    for (ci = 0; ci < checked.length; ci++) {
      ch = checked[ci];
      ix = parseInt(ch.getAttribute('data-cart-line-index') || '-1', 10);
      if (ix < 0 || ix >= len || seen[ix]) continue;
      seen[ix] = true;
      idxs.push(ix);
    }
    idxs.sort(function (a, b) {
      return a - b;
    });
    return idxs.map(function (i) {
      return cloneLineWithQuantity(allLines[i], readQtyForCartLine(root, i), i);
    });
  }

  function readAtcLineQuantity(line) {
    if (!line) return 0;
    if (typeof line.quantity === 'number' && !isNaN(line.quantity)) return line.quantity;
    var n = parseInt(str(line.quantity), 10);
    return isNaN(n) ? 0 : n;
  }

  function atcVariantIdsFromLines(atcParentLines) {
    var ids = Object.create(null);
    var li;
    var line;
    var vid;
    var taxes;
    var ti;
    for (li = 0; li < atcParentLines.length; li++) {
      line = atcParentLines[li];
      vid = str(line.id).trim();
      if (vid) ids[vid] = true;
      taxes = Array.isArray(line.tax) ? line.tax : [];
      for (ti = 0; ti < taxes.length; ti++) {
        vid = str(taxes[ti].id).trim();
        if (vid) ids[vid] = true;
      }
    }
    return ids;
  }

  function cartItemsAddedByAtc(cartData, atcParentLines) {
    var atcVariantIds = atcVariantIdsFromLines(atcParentLines);
    var cartItems = Array.isArray(cartData.items) ? cartData.items : cartData.item ? [cartData.item] : [];
    return cartItems.filter(function (row) {
      return atcVariantIds[str(row.variant_id)];
    });
  }

  function totalValueFromCartItems(items) {
    var totalCents = 0;
    var i;
    var row;
    for (i = 0; i < items.length; i++) {
      row = items[i];
      totalCents += Number(row.final_line_price) || Number(row.line_price) || 0;
    }
    return totalCents / 100;
  }

  function publishPreviousOrderReorderFromCart(root, atcParentLines, cartData) {
    if (!root || !cartData || !Array.isArray(atcParentLines) || atcParentLines.length === 0) return;

    var orderName = str(root.getAttribute('data-order-name')).trim();
    if (!orderName) orderName = str(root.getAttribute('data-order-id'));

    var items = cartItemsAddedByAtc(cartData, atcParentLines);
    if (!items.length) {
      items = atcParentLines.map(function (line) {
        return {
          variant_id: line.id,
          quantity: readAtcLineQuantity(line),
        };
      });
    }

    var payload = {
      order_id: orderName,
      items: items,
      total_value: totalValueFromCartItems(items),
    };

    if (
      window.alteregoAnalytics &&
      typeof window.alteregoAnalytics.trackPreviousOrderReorder === 'function'
    ) {
      window.alteregoAnalytics.trackPreviousOrderReorder(payload);
    }
  }

  function executeCartAdd(btn, sectionRoot, root, lines) {
    if (!btn || !root || !Array.isArray(lines) || lines.length === 0) return;

    var atcParentLines = lines.map(function (line) {
      return cloneLineWithQuantity(line, readAtcLineQuantity(line), line._cart_line_index);
    });

    var cart = getCartUi();
    var fd = buildFormData(atcParentLines);

    if (cart && typeof cart.getSectionsToRender === 'function') {
      fd.append(
        'sections',
        cart.getSectionsToRender().map(function (s) {
          return s.id;
        })
      );
      fd.append('sections_url', window.location.pathname);
    }

    btn.classList.add('loading');
    btn.setAttribute('aria-disabled', 'true');
    setSpinnerVisible(btn, true);

    fetch(str(window.routes.cart_add_url), {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
      body: fd,
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        if (data.status || data.errors) {
          var msg =
            (typeof data.description === 'string' && data.description) ||
            (Array.isArray(data.errors) && data.errors.join(', ')) ||
            'Could not add items to cart';
          if (sectionRoot) flashLiveRegion(sectionRoot, msg);
          dispatchBuyAgain('buy-again:cart-add-error', {
            message: msg,
            orderId: root.getAttribute('data-order-id'),
          });
          return;
        }

        publishPreviousOrderReorderFromCart(root, atcParentLines, data);

        if (cart && typeof cart.renderContents === 'function') {
          try {
            cart.renderContents(data);
          } catch (renderErr) {
            console.error('buy-again cart renderContents failed:', renderErr);
          }
        }

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'buy-again-order-atc', cartData: data });
        }

        dispatchBuyAgain('buy-again:cart-add-success', {
          orderId: root.getAttribute('data-order-id'),
          lineCount: atcParentLines.length,
        });
      })
      .catch(function (err) {
        var msg = err && err.message ? str(err.message) : 'Could not add items to cart';
        if (sectionRoot) flashLiveRegion(sectionRoot, msg);
        dispatchBuyAgain('buy-again:cart-add-error', {
          message: msg,
          orderId: root.getAttribute('data-order-id'),
          network: true,
        });
      })
      .finally(function () {
        btn.classList.remove('loading');
        btn.removeAttribute('aria-disabled');
        setSpinnerVisible(btn, false);
      });
  }

  function appendNestedTaxes(copyEl, nestedTaxes) {
    if (!Array.isArray(nestedTaxes) || nestedTaxes.length === 0) return;
    var wrap = document.createElement('div');
    wrap.className = 'buy-again-order-items__tax-list';
    var i;
    var tax;
    var row;
    var inner;
    var thumb;
    var img;
    var text;
    var title;
    var meta;
    for (i = 0; i < nestedTaxes.length; i++) {
      tax = nestedTaxes[i];
      row = document.createElement('div');
      row.className = 'buy-again-order-items__nested-line';
      inner = document.createElement('div');
      inner.className = 'buy-again-order-items__nested-inner';
      if (tax.thumb_url) {
        thumb = document.createElement('div');
        thumb.className = 'buy-again-order-items__nested-thumb';
        img = document.createElement('img');
        img.src = tax.thumb_url;
        img.alt = '';
        img.loading = 'lazy';
        img.decoding = 'async';
        thumb.appendChild(img);
        inner.appendChild(thumb);
      }
      text = document.createElement('div');
      text.className = 'buy-again-order-items__nested-text';
      title = document.createElement('p');
      title.className = 'buy-again-order-items__nested-title';
      title.textContent = str(tax.title);
      meta = document.createElement('p');
      meta.className = 'buy-again-order-items__nested-meta';
      meta.textContent = str(tax.amount_money);
      text.appendChild(title);
      text.appendChild(meta);
      inner.appendChild(text);
      row.appendChild(inner);
      wrap.appendChild(row);
    }
    copyEl.appendChild(wrap);
  }

  function qtySlotSelector(orderId, cartLineIndex) {
    return (
      'template[data-buy-again-qty-slot][data-order-id="' +
      orderId +
      '"][data-cart-line-index="' +
      cartLineIndex +
      '"]'
    );
  }

  function renderOrderArticle(order, i18n, sectionEl) {
    var sid = str(order.section_id);
    var oid = order.id;
    var oidStr = str(oid);
    var bank = sectionEl && sectionEl.querySelector ? sectionEl.querySelector('[data-buy-again-qty-bank]') : null;
    var article = document.createElement('article');
    article.className = 'buy-again-order-items__order buy-again-order-items__order-card';
    article.setAttribute('data-buy-again-order-root', '');
    article.setAttribute('data-order-id', oidStr);
    article.setAttribute('data-order-name', str(order.name));

    var headingId = 'buy-again-order-heading-' + sid + '-' + oidStr;
    article.setAttribute('aria-labelledby', headingId);

    var header = document.createElement('header');
    header.className = 'buy-again-order-items__order-header';
    var h3 = document.createElement('h3');
    h3.id = headingId;
    h3.className = 'buy-again-order-items__order-title';
    h3.textContent = replaceNamePlaceholder(i18n.order_title, order.name);
    var metaP = document.createElement('p');
    metaP.className = 'buy-again-order-items__order-meta caption';
    metaP.textContent = [order.created_at_label, order.financial_status_label, order.fulfillment_status_label]
      .filter(function (x) {
        return x != null && str(x).length > 0;
      })
      .join(' · ');
    header.appendChild(h3);
    header.appendChild(metaP);
    article.appendChild(header);

    var linesRegion = document.createElement('div');
    linesRegion.className = 'buy-again-order-items__lines';
    linesRegion.setAttribute('role', 'region');
    linesRegion.setAttribute('aria-label', replaceNamePlaceholder(i18n.line_items_caption, order.name));

    var headGrid = document.createElement('div');
    headGrid.className =
      'buy-again-order-items__grid buy-again-order-items__grid--head buy-again-order-items__grid--head-desktop';
    headGrid.setAttribute('aria-hidden', 'true');

    HEAD_COLS.forEach(function (col) {
      var span = document.createElement('span');
      span.className =
        'buy-again-order-items__grid-col buy-again-order-items__grid-col--' +
        col[0] +
        ' caption-with-letter-spacing';
      span.textContent = str(i18n[col[1]]);
      headGrid.appendChild(span);
    });
    linesRegion.appendChild(headGrid);

    var ul = document.createElement('ul');
    ul.className = 'buy-again-order-items__line-list list-unstyled';
    ul.setAttribute('role', 'list');

    var frag = document.createDocumentFragment();
    var displayLines = Array.isArray(order.display_lines) ? order.display_lines : [];
    var cartLines = Array.isArray(order.cart_lines) ? order.cart_lines : [];
    var cartLen = cartLines.length;
    var li;
    var dl;
    var item;
    var grid;
    var colProduct;
    var cell;
    var thumb;
    var img;
    var copy;
    var titleSpan;
    var cap;
    var cartLineIndex;
    var controls;
    var cb;
    var lineBtn;
    var colAction;
    var colQty;
    var tpl;
    var inStock;

    for (li = 0; li < displayLines.length; li++) {
      dl = displayLines[li];
      cartLineIndex = displayLineCartIndex(dl);
      inStock = cartLineIndex >= 0 && cartLineIndex < cartLen;

      item = document.createElement('li');
      item.className = 'buy-again-order-items__line-item';
      item.setAttribute('role', 'listitem');

      grid = document.createElement('div');
      grid.className = 'buy-again-order-items__grid buy-again-order-items__grid--line';

      colProduct = document.createElement('div');
      colProduct.className = 'buy-again-order-items__grid-col buy-again-order-items__grid-col--product';
      colProduct.setAttribute('data-label', str(i18n.column_product));

      cell = document.createElement('div');
      cell.className = 'buy-again-order-items__product-cell';

      controls = document.createElement('div');
      controls.className = 'buy-again-order-items__line-controls';
      cb = document.createElement('input');
      cb.type = 'checkbox';
      if (inStock) {
        cb.setAttribute('data-buy-again-line-check', '');
        cb.setAttribute('data-cart-line-index', str(cartLineIndex));
        cb.setAttribute('aria-label', replaceNamePlaceholder(str(i18n.line_select_aria), dl.title));
      } else {
        cb.disabled = true;
        cb.setAttribute('aria-disabled', 'true');
        cb.setAttribute('aria-label', str(i18n.stock_out_of_stock) + (dl.title ? ': ' + str(dl.title) : ''));
      }
      controls.appendChild(cb);
      cell.appendChild(controls);

      if (dl.image_url) {
        thumb = document.createElement('div');
        thumb.className = 'buy-again-order-items__thumb';
        img = document.createElement('img');
        img.src = dl.image_url;
        img.alt = str(dl.title);
        img.loading = 'lazy';
        img.decoding = 'async';
        thumb.appendChild(img);
        cell.appendChild(thumb);
      }

      copy = document.createElement('div');
      copy.className = 'buy-again-order-items__product-copy';
      titleSpan = document.createElement('span');
      titleSpan.className = 'buy-again-order-items__product-title';
      titleSpan.textContent = str(dl.title);
      copy.appendChild(titleSpan);

      if (dl.variant_title != null && String(dl.variant_title).length > 0) {
        cap = document.createElement('p');
        cap.className = 'caption';
        cap.textContent = String(dl.variant_title);
        copy.appendChild(cap);
      }

      appendNestedTaxes(copy, dl.nested_taxes);
      cell.appendChild(copy);
      colProduct.appendChild(cell);

      grid.appendChild(colProduct);
      grid.appendChild(labeledCol(i18n, 'price', 'column_price', dl.price_money));

      colQty = document.createElement('div');
      colQty.className = 'buy-again-order-items__grid-col buy-again-order-items__grid-col--qty';
      colQty.setAttribute('data-label', str(i18n.column_quantity));
      if (inStock) {
        tpl = bank && bank.querySelector(qtySlotSelector(oidStr, cartLineIndex));
        if (tpl && tpl.content) {
          colQty.appendChild(tpl.content.cloneNode(true));
        } else {
          colQty.textContent = str(dl.quantity);
        }
      } else {
        colQty.textContent = str(dl.quantity);
      }
      grid.appendChild(colQty);

      colAction = document.createElement('div');
      colAction.className = 'buy-again-order-items__grid-col buy-again-order-items__grid-col--action';
      if (inStock) {
        colAction.setAttribute('data-label', str(i18n.column_add));
        lineBtn = document.createElement('button');
        lineBtn.type = 'button';
        lineBtn.className = 'button button--secondary buy-again-order-items__line-atc';
        lineBtn.setAttribute('data-buy-again-line-atc', '');
        lineBtn.setAttribute('data-cart-line-index', str(cartLineIndex));
        appendLabelAndSpinner(lineBtn, i18n.line_add_to_cart);
        colAction.appendChild(lineBtn);
      } else {
        colAction.setAttribute('data-label', str(i18n.column_add));
        colAction.classList.add('buy-again-order-items__grid-col--action--unavailable');
        var actionUnavailable = document.createElement('p');
        actionUnavailable.className = 'buy-again-order-items__line-unavailable caption';
        actionUnavailable.setAttribute('role', 'status');
        actionUnavailable.textContent = str(i18n.stock_out_of_stock);
        colAction.appendChild(actionUnavailable);
      }
      grid.appendChild(colAction);

      item.appendChild(grid);
      frag.appendChild(item);
    }

    ul.appendChild(frag);
    linesRegion.appendChild(ul);
    article.appendChild(linesRegion);

    var footer = document.createElement('footer');
    footer.className = 'buy-again-order-items__order-footer';
    var actions = document.createElement('div');
    actions.className = 'buy-again-order-items__footer-actions';

    var addSelected = document.createElement('button');
    addSelected.type = 'button';
    addSelected.className = 'button button--secondary buy-again-order-items__atc buy-again-order-items__atc--selected';
    addSelected.setAttribute('data-buy-again-selected-atc', '');
    appendLabelAndSpinner(addSelected, i18n.add_selected_to_cart);
    if (i18n.selected_add_none_hint) {
      addSelected.setAttribute('data-msg-empty', str(i18n.selected_add_none_hint));
    }
    addSelected.disabled = true;

    var atc = document.createElement('button');
    atc.type = 'button';
    atc.className = 'button button--primary buy-again-order-items__atc';
    atc.setAttribute('data-buy-again-order-atc', '');
    appendLabelAndSpinner(atc, i18n.add_order_to_cart);
    if (cartLen === 0) {
      atc.disabled = true;
      if (i18n.no_reorderable_items) {
        atc.title = str(i18n.no_reorderable_items);
      } else if (i18n.order_unavailable) {
        atc.title = str(i18n.order_unavailable);
      }
    } else {
      atc.disabled = false;
      if (order.can_full === false && i18n.reorder_skips_unavailable) {
        atc.title = str(i18n.reorder_skips_unavailable);
      } else {
        atc.removeAttribute('title');
      }
    }

    actions.appendChild(addSelected);
    actions.appendChild(atc);
    footer.appendChild(actions);

    var payloadScript = document.createElement('script');
    payloadScript.type = 'application/json';
    payloadScript.setAttribute('data-buy-again-lines', '');
    payloadScript.textContent = JSON.stringify(cartLines);

    footer.appendChild(payloadScript);
    article.appendChild(footer);

    updateSelectedAtcState(article);

    return article;
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.matches || !t.matches('input[type="checkbox"][data-buy-again-line-check]')) return;
    var root = t.closest('[data-buy-again-order-root]');
    if (root) updateSelectedAtcState(root);
  });

  document.addEventListener('click', function (e) {
    var orderAtc = e.target.closest('[data-buy-again-order-atc]');
    var lineAtc = e.target.closest('[data-buy-again-line-atc]');
    var selAtc = e.target.closest('[data-buy-again-selected-atc]');
    var btn = orderAtc || lineAtc || selAtc;
    if (!btn || btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;

    var root = btn.closest('[data-buy-again-order-root]');
    if (!root) return;

    var sectionRoot = btn.closest('[data-buy-again-order-section]');
    var parsed = parseCartLinesFromRoot(root);
    var allLines = parsed.lines;
    if (parsed.parseError) {
      var parseMsg = parsed.parseErrorMessage || 'Could not add items to cart';
      if (sectionRoot) flashLiveRegion(sectionRoot, parseMsg);
      dispatchBuyAgain('buy-again:cart-add-error', {
        reason: 'parse',
        message: parseMsg,
        orderId: root.getAttribute('data-order-id'),
      });
      return;
    }
    if (allLines.length === 0) return;

    var lines;
    var lix;
    if (orderAtc) {
      lines = linesWithQuantitiesForFullOrder(root, allLines);
    } else if (lineAtc) {
      lix = parseInt(lineAtc.getAttribute('data-cart-line-index') || '-1', 10);
      if (lix < 0 || lix >= allLines.length) return;
      lines = [cloneLineWithQuantity(allLines[lix], readQtyForCartLine(root, lix), lix)];
    } else {
      lines = linesFromCheckedSelection(root, allLines);
      if (lines.length === 0) {
        var emptyMsg = btn.getAttribute('data-msg-empty');
        if (selAtc && sectionRoot && emptyMsg) flashLiveRegion(sectionRoot, emptyMsg);
        return;
      }
    }

    executeCartAdd(btn, sectionRoot, root, lines);
  });

  function initBuyAgainOrderMount() {
    var wanted = '';
    try {
      var q = new URLSearchParams(window.location.search).get('order');
      wanted = q != null ? str(q).trim() : '';
    } catch (e) {}

    var sections = document.querySelectorAll('[data-buy-again-order-section]');
    var si;
    var section;
    var dataEl;
    var i18nEl;
    var mount;
    var msgNoParam;
    var msgNotFound;
    var orders;
    var i18n;
    var order;
    var oi;

    for (si = 0; si < sections.length; si++) {
      section = sections[si];
      mount = section.querySelector('[data-buy-again-mount]');
      if (!mount) continue;

      dataEl = section.querySelector('[data-buy-again-orders-data]');
      i18nEl = section.querySelector('[data-buy-again-i18n]');
      msgNoParam = section.querySelector('[data-buy-again-msg-no-order-param]');
      msgNotFound = section.querySelector('[data-buy-again-msg-order-not-found]');

      orders = parseJsonEl(dataEl, []);
      if (!Array.isArray(orders)) orders = [];

      i18n = parseJsonEl(i18nEl, {});

      function hideMsgs() {
        if (msgNoParam) msgNoParam.hidden = true;
        if (msgNotFound) msgNotFound.hidden = true;
      }

      mount.innerHTML = '';
      mount.hidden = true;

      if (orders.length === 0) {
        hideMsgs();
        continue;
      }

      if (!wanted) {
        hideMsgs();
        if (msgNoParam) msgNoParam.hidden = false;
        continue;
      }

      order = null;
      for (oi = 0; oi < orders.length; oi++) {
        if (orders[oi] && str(orders[oi].id) === wanted) {
          order = orders[oi];
          break;
        }
      }

      if (!order) {
        hideMsgs();
        if (msgNotFound) msgNotFound.hidden = false;
        continue;
      }

      hideMsgs();
      mount.hidden = false;
      publishReorderClick(order);
      mount.appendChild(renderOrderArticle(order, i18n, section));
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBuyAgainOrderMount, { once: true });
  } else {
    initBuyAgainOrderMount();
  }
})();
